import React from "react";
import ConditionalTooltipWrapper from "../../../helpers/components/ConditionalTooltipWrapper";
import useChipCheckbox from "./hooks/useChipCheckbox";
import { BaseChipCheckbox, BaseChipCheckboxIcon } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ChipCheckbox(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Ack" : _ref$label,
    isChecked = _ref.isChecked,
    onClick = _ref.onClick,
    isLoading = _ref.isLoading,
    tooltipContent = _ref.tooltipContent,
    isDisabled = _ref.isDisabled;
  var _useChipCheckbox = useChipCheckbox({
      onClick: onClick,
      isLoading: isLoading,
      isChecked: isChecked
    }),
    handleClick = _useChipCheckbox.handleClick,
    icon = _useChipCheckbox.icon,
    state = _useChipCheckbox.state;
  return /*#__PURE__*/_jsx(ConditionalTooltipWrapper, {
    tooltipContent: tooltipContent,
    children: /*#__PURE__*/_jsxs(BaseChipCheckbox, {
      state: state,
      onClick: !isDisabled && handleClick,
      disabled: isDisabled,
      children: [/*#__PURE__*/_jsx(BaseChipCheckboxIcon, {
        state: state,
        children: icon
      }), label]
    })
  });
}
export default ChipCheckbox;